/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Voice_Manager_Low_Quality_BadgeInputs */

const en_voice_manager_low_quality_badge = /** @type {(inputs: Voice_Manager_Low_Quality_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Low quality`)
};

const fr_voice_manager_low_quality_badge = /** @type {(inputs: Voice_Manager_Low_Quality_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`de mauvaise qualité`)
};

const de_voice_manager_low_quality_badge = /** @type {(inputs: Voice_Manager_Low_Quality_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Niedrige Qualität`)
};

const it_voice_manager_low_quality_badge = /** @type {(inputs: Voice_Manager_Low_Quality_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bassa qualità`)
};

const ru_voice_manager_low_quality_badge = /** @type {(inputs: Voice_Manager_Low_Quality_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Низкое качество`)
};

const es_voice_manager_low_quality_badge = /** @type {(inputs: Voice_Manager_Low_Quality_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baja calidad`)
};

const zh_cn2_voice_manager_low_quality_badge = /** @type {(inputs: Voice_Manager_Low_Quality_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`低质量`)
};

const ja_voice_manager_low_quality_badge = /** @type {(inputs: Voice_Manager_Low_Quality_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`低品質`)
};

const hi_voice_manager_low_quality_badge = /** @type {(inputs: Voice_Manager_Low_Quality_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`खराब क्वालिटी`)
};

const pt_pt2_voice_manager_low_quality_badge = /** @type {(inputs: Voice_Manager_Low_Quality_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baixa qualidade`)
};

/**
* | output |
* | --- |
* | "Low quality" |
*
* @param {Voice_Manager_Low_Quality_BadgeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const voice_manager_low_quality_badge = /** @type {((inputs?: Voice_Manager_Low_Quality_BadgeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Voice_Manager_Low_Quality_BadgeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_voice_manager_low_quality_badge(inputs)
	if (locale === "de") return de_voice_manager_low_quality_badge(inputs)
	if (locale === "it") return it_voice_manager_low_quality_badge(inputs)
	if (locale === "ru") return ru_voice_manager_low_quality_badge(inputs)
	if (locale === "es") return es_voice_manager_low_quality_badge(inputs)
	if (locale === "zh-CN") return zh_cn2_voice_manager_low_quality_badge(inputs)
	if (locale === "ja") return ja_voice_manager_low_quality_badge(inputs)
	if (locale === "hi") return hi_voice_manager_low_quality_badge(inputs)
	if (locale === "pt-PT") return pt_pt2_voice_manager_low_quality_badge(inputs)
	return en_voice_manager_low_quality_badge(inputs)
});